import TextBasedSectionContainer from '@/components/TextBasedSectionContainer'
import { PageSEO } from '@/components/SEO'

export default function Imprint() {
  return (
    <>
      <PageSEO
        title={`Animerdle - Imprint`}
        description={`Animerdle imprint`}
        keywords={'animerdle imprint'}
      />
      <TextBasedSectionContainer title={'Imprint'}>
        <div className="prose max-w-none dark:prose-dark">
          <p>Media proprietor: animerdle.com</p>
          <p>Business purpose is the provision of mini games on the World Wide Web.</p>
          <p>Contact: animerdleofficial@gmail.com</p>
        </div>
      </TextBasedSectionContainer>
    </>
  )
}
